var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }